import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TErrorCorrectionsApi } from './types';

export const errorCorrections: TErrorCorrectionsApi = {
	getErrorCorrections: (payload) =>
		http
			.post(endpoint.errorCorrections.ORDER_CORRECTIONS, payload)
			.then((response) => response.data),
	getErrorCorrection: (params) =>
		http
			.get(endpoint.errorCorrections.ORDER_CORRECTION(params.errorId))
			.then((response) => response.data),
	getErrorTypes: () =>
		http.get(endpoint.errorCorrections.ERROR_TYPES).then((response) => response.data),
	getErrorCorrectionsScriptHistory: (params) =>
		http
			.get(endpoint.errorCorrections.SCRIPTS_HISTORY(params.errorId))
			.then((response) => response.data),
	updateErrorCorrectionComment: (payload) =>
		http.post(endpoint.errorCorrections.UPDATE_COMMENT(payload.errorId), payload),
	updateErrorCorrectionCommunicationWithClient: (payload) =>
		http.post(endpoint.errorCorrections.UPDATE_COMMUNICATION_WITH_CLIENT(payload.errorId), payload),
	updateErrorCorrectionProposedSolution: (payload) =>
		http.post(endpoint.errorCorrections.UPDATE_PROPOSED_SOLUTION(payload.errorId), payload),
	updateErrorCorrectionResponsibleUser: (payload) =>
		http.post(endpoint.errorCorrections.SET_RESPONSIBLE_USER(payload.errorId), payload),
	updateErrorCorrectionStatus: (payload) =>
		http.post(endpoint.errorCorrections.SET_STATUS(payload.errorId), { text: payload.text }),
	getScripts: () => http.get(endpoint.errorCorrections.SCRIPTS).then((response) => response.data),
	startScript: (payload) =>
		http
			.post(
				endpoint.errorCorrections.START_SCRIPT(payload.errorId, payload.scriptId),
				payload.parameters,
			)
			.then((response) => response.data),
	getUserStatistic: () =>
		http.get(endpoint.errorCorrections.USER_STATISTICS).then((response) => response.data),
	getLaunchedScripts: (params) =>
		http
			.get(endpoint.errorCorrections.LAUNCHED_SCRIPTS(params.orderId))
			.then((response) => response.data),
	startScriptByOrder: (payload) =>
		http
			.post(
				endpoint.errorCorrections.START_SCRIPT_BY_ORDER(payload.id, payload.scriptId),
				payload.body,
			)
			.then((response) => response.data),
};
